/**
 * 旅程标题拼进一句话（旅途页状态卡的退路、在家时“上一趟”那一行）。
 * destination_title 本身已经是完整的短语——后端的标题像“去附近喝一杯”“去渔港帮忙收网”“坐船去澳门”“自己开车去兜风”
 * “在家附近走走”“进城逛逛”“海边咖啡馆”——前面不再拼“去”：原来写成“这趟去 去对岸看看”“上一次去了 去附近喝一杯”，
 * “去”不在开头的（坐船去澳门）、不是“去哪儿”的（在家附近走走）拼上“去”也不通。
 * 用冒号引出，动词短语和地名都说得通；没有标题（或只有空白）时返回 null，由调用方换一句不带标题的话。
 */
export function tripTitleLine(lead: string, title: string | null | undefined): string | null {
  const text = title?.trim();
  return text ? `${lead}：${text}` : null;
}
